export const FETCH_ORDERS = 'FETCH_ORDERS';
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_FAILED = 'FETCH_ORDERS_FAILED';
export const HANDLE_TAB_CHANGE = 'HANDLE_TAB_CHANGE';
export const SET_ORDERS = 'SET_ORDERS';
export const HANDLE_MODIFIED_ORDERS = 'HANDLE_MODIFIED_ORDERS';
